var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detail.joinActivity)?_c('div',{staticClass:"footer-poup"},[_vm._v(" "+_vm._s(_vm.isDcsj ? "限时！邀好友，得训练营" : ("限时邀请好友减" + (_vm.detail.cutAmount || "")))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }